import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import { TableCell } from './MemberList';
import styles from './chat.module.css';
import ListLoader from './ListLoader';
const ListItem = (props) => {
  const { item, allMessages, unreadMsgCount, chat, onClick } = props;
  const { name, chatUserId } = item;

  return (
    <TableRow>
      <TableCell style={{ width: 350 }} onClick={onClick}>
        <div
          style={{
            fontWeight: !!unreadMsgCount[chatUserId] ? 'bold' : 'normal',
            fontSize: '14px',
            fontFamily: 'Work Sans',
          }}
        >
          {name || item.chatUserId}
        </div>
        {!!unreadMsgCount[chatUserId] && (
          <div className={styles.count}>{unreadMsgCount[chatUserId]}</div>
        )}
      </TableCell>
      <TableCell align="left" style={{ fontSize: '14px', fontFamily: 'Work Sans' }}>
        {chat[`loader${chatUserId}`] ? <ListLoader /> : allMessages[chatUserId]?.text}
      </TableCell>
      <TableCell style={{ width: 200, fontSize: '14px', fontFamily: 'Work Sans' }} align="left">
        {chat[`loader${chatUserId}`] ? (
          <ListLoader />
        ) : allMessages[chatUserId]?.time ? (
          moment(new Date(allMessages[chatUserId]?.time)).format('lll')
        ) : (
          ''
        )}
      </TableCell>
    </TableRow>
  );
};
export default ListItem;
